// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  message: 'production',
  production: true,
  baseURL         : "https://api.",
  environmentURL  : "master.test.ccloud.cl",
  baseTest        : ".test.ccloud.cl",
  apiVersions     : "https://app.master.test.ccloud.cl/api/v2/public/api/codecommit/branches",
  SERVER_CONFIG   : {
    calidadUrl      : '/api/v2/public/api',
    accesoUrl       : 'propietarios/acceso',
    garantias       : '/empresas/',
    garantias_part2 : '/garantias'
  }
};

if (environment.message === "testing") {
  environment.environmentURL = "master.test.ccloud.cl";
}
if (environment.message === "dev") {
  environment.environmentURL = "master.test.ccloud.cl";
}
if (environment.message === "production") {
  environment.environmentURL = "ccloud.cl";
}